<template>
  <el-container class="f-h">
    <el-header class="toolbar" style="height: 2.5rem">
      <el-row type="flex" justify="space-between" class="sub-title left">
        <div>
          收费：
          <el-button
            type="primary"
            size="small"
            icon="el-icon-bank-card"
            @click="(entity = {}), (meta.showPay = true)"
            v-if="permission.registration_charge_create"
            >门诊收费
          </el-button>
          <id-reader
            @ok="receiveIdCard"
            :is-used-dialog="false"
            text="读取身份证并收费"
          />
          <el-button
            type="info"
            size="small"
            icon="el-icon-setting"
            @click="printConfig"
            plain
            >打印机配置</el-button
          >
        </div>
        <div>
          <!-- <el-date-picker v-model="condition.paymentDate" type="date" size="small" value-format="yyyy-MM-dd" placeholder="收费时间">
          </el-date-picker> -->
          <el-date-picker
            v-model="dateRange"
            size="small"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="dateRangeChanged"
            :clearable="false"
            class="condition-input"
            style="width: 19rem"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
          <staff-selector
            v-model="condition.operatorUserId"
            placeholder="收费员"
            class="edit-input left-pad"
            @change="page"
          ></staff-selector>
          <el-input
            size="small"
            class="left-pad condition-wide"
            type="text"
            v-on:keyup.enter.native="page"
            clearable
            placeholder="患者姓名或发票号"
            v-model="condition.nameOrInvoiceNo"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click.native="page"
              :loading="meta.loading"
            ></el-button>
          </el-input>
        </div>
      </el-row>
    </el-header>
    <el-main class="left" style="padding: 0px">
      <el-table
        v-loading="meta.loading"
        @filter-change="filterChanged"
        height="100%"
        :data="entities.items"
        :row-class-name="tableRowClassName"
        @sort-change="handleSortChange"
        class="main-table"
      >
        <!-- <el-table-column label="操作" align="center" width="150">
                <template slot-scope="{row}">
                    <el-button v-if="permission.registration_registry_delete" title="退费" type="danger" plain size="mini" circle icon="el-icon-delete" :disabled="row.offsetFlag != '正常'" @click="refund(row)"></el-button>
                    <el-button v-if="true || permission.registration_registry_print" title="详细" type="info" plain size="mini" circle icon="el-icon-search" class="left-pad" @click="view(row)"></el-button>
                    <el-button type="warning" icon="el-icon-printer" circle size="small" title="补打发票" class="left-pad" plain :disabled="!!row.invoiceNo || row.offsetFlag == '冲单' || row.offsetFlag == '原单'" @click="printInvoice(row)"></el-button>
                </template>
</el-table-column> -->
        <!-- <el-table-column label="支付状态" :filters="dictEnum.PaymentState" :filter-multiple="false" column-key="state" sortable="custom" width="120" prop="state" align="center">
                <template slot-scope="scope">
                    <el-tag size="small" effect="plain" :type="types(scope.row.state)">{{ scope.row.state }}</el-tag>
                </template>
            </el-table-column> -->
        <el-table-column
          label="支付流水号"
          sortable="custom"
          width="160"
          prop="no"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-link
              v-if="row.disabled"
              @click="view(row)"
              style="color: #eca51c"
              >{{ row.no }}</el-link
            >
            <el-link
              v-else
              :type="row.type == '收费' ? 'primary' : 'danger'"
              @click="view(row)"
              >{{ row.no }}</el-link
            >
          </template>
        </el-table-column>
        <el-table-column label="发票号" prop="invoiceNo" align="center">
          <template slot-scope="{ row }">
            <el-link @click="openSelect(row)" type="primary">
              {{ row.invoiceNo || "开票" }}</el-link
            >
          </template>
        </el-table-column>

        <el-table-column
          label="收款方式"
          sortable="custom"
          prop="payWay"
          width="130"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>{{ row.payWay | dictText("PayWay") }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="患者姓名"
          prop="patientName"
          width="120"
          align="center"
        ></el-table-column>
        <el-table-column
          label="就诊类型"
          :filters="dictEnum.OpType"
          :filter-multiple="false"
          column-key="opType"
          prop="opType"
          width="100"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-tag
              v-if="row.opType == '医保工伤'"
              type="danger"
              size="small"
              effect="plain"
              >{{ row.opType }}</el-tag
            >
            <el-tag
              v-else-if="row.opType == '医保'"
              type="warning"
              size="small"
              effect="plain"
              >{{ row.opType }}</el-tag
            >
            <el-tag v-else type="success" size="small" effect="plain">{{
              row.opType
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="费用总额"
          prop="feeAmount"
          width="120"
          align="right"
        >
          <template slot-scope="{ row }">
            ￥{{ row.feeAmount | fmtFloat(2) }}
          </template>
        </el-table-column>
        <el-table-column
          label="发票金额"
          prop="feeCash"
          width="120"
          align="right"
        >
          <template slot-scope="{ row }">
            <!-- 支付类型为医保，并且没有折扣时，发票金额取值为“费用总额” -->
            <span
              class="orange"
              v-if="row.opType === '医保' && row.feeDiscount === 0"
            >
              ￥{{ row.feeAmount | fmtFloat(2) }}
            </span>
            <span class="orange" v-else-if="row.payWay === 'enterprise'"
              >￥{{ row.feeAmount | fmtFloat(2) }}</span
            >
            <span class="orange" v-else>￥{{ row.feeCash | fmtFloat(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="医保基金支付"
          prop="feeFund"
          width="120"
          align="right"
        >
          <template slot-scope="{ row }">
            ￥{{ row.feeFund | fmtFloat(2) }}
          </template>
        </el-table-column>
        <el-table-column
          label="个人支付金额"
          prop="feeFund"
          width="120"
          align="right"
        >
          <template slot-scope="{ row }">
            ￥{{ row.feeCash | fmtFloat(2) }}
          </template>
        </el-table-column>
        <el-table-column
          label="折扣金额"
          prop="feeFund"
          width="120"
          align="right"
        >
          <template slot-scope="{ row }">
            ￥{{ row.feeDiscount | fmtFloat(2) }}
          </template>
        </el-table-column>

        <el-table-column
          sortable="custom"
          label="类型"
          :filters="dictEnum.PaymentType"
          :filter-multiple="false"
          :filtered-value="['全部']"
          column-key="type"
          prop="type"
          width="130"
        >
          <template slot-scope="{ row }">
            <el-tag
              v-if="row.type === '退费'"
              type="danger"
              effect="dark"
              size="small"
            >
              {{ row.type }}
            </el-tag>
            <el-tag v-else type="success" effect="plain" size="mini">{{
              row.type
            }}</el-tag>
            <el-tag
              v-if="row.disabled"
              size="mini"
              style="
                background: #ffffff;
                color: #ff9900;
                border: 1px solid #ff9900;
              "
            >
              待退费
            </el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column sortable="custom" label="冲单" align="center" width="80">
          <template slot-scope="{ row }">
            <el-tag v-if="row.offsetFlag == '原单'" type="success" effect="plain" size="mini">原</el-tag>
            <el-tag v-if="row.offsetFlag == '冲单'" type="danger" effect="plain" size="mini">冲</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column
          label="收费员"
          prop="operatorUserName"
          align="center"
        ></el-table-column>
        <el-table-column
          label="收费时间"
          sortable="custom"
          prop="execDate"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.execDate | fmtDateTime }}
          </template>
        </el-table-column>
        <el-table-column
          label="关联收费单"
          width="150"
          prop="orderNo"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-link
              v-if="row.orginPayment?.no"
              @click="view(row.orginPayment)"
              type="primary"
            >
              {{ row.orginPayment?.no }}</el-link
            >
            <span v-if="row.orginPayment?.no && row.newPayment?.no">,</span>

            <el-link
              v-if="row.newPayment?.no"
              @click="view(row.newPayment)"
              type="primary"
            >
              {{ row.newPayment?.no }}</el-link
            >
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <charge
      @paid="page"
      :entity="entity"
      :visible.sync="meta.showPay"
      :id-card="idCard"
    ></charge>
    <detail
      :entity="entity"
      :visible.sync="meta.showDetail"
      @refunded="page"
      @paid="page"
    ></detail>
    <pagination
      :entities="entities"
      @queryEntities="page"
      :condition="condition"
    />
    <printView
      :visible.sync="showPrintView"
      :printNameList="printNameList"
    ></printView>
    <!-- 非公医弹窗 -->
    <el-dialog title="电子发票" :visible.sync="payWayNoGy" width="30%">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
      >
        <el-form-item label="开票类型" prop="medicalCareType">
          <el-select
            v-model="ruleForm.medicalCareType"
            placeholder="请选择开票类型"
            style="width: 100%"
          >
            <el-option
              label="职工基本医疗保险"
              value="职工基本医疗保险"
            ></el-option>
            <el-option
              label="城乡居民基本医疗保险"
              value="城乡居民基本医疗保险"
            ></el-option>
            <el-option label="其他医疗保险" value="其他医疗保险"></el-option>
            <el-option label="非医保" value="非医保"></el-option>
            <el-option label="冲红" value="冲红"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="冲红原因"
          prop="reason"
          v-if="ruleForm.medicalCareType === '冲红'"
        >
          <el-input v-model="ruleForm.reason"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payWayNoGy = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 公医弹窗 -->
    <el-dialog title="电子发票" :visible.sync="payWayGy" width="50%">
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="payWayNoGy = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span> -->
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="payNo" label="公医支付流水号"> </el-table-column>
        <el-table-column prop="amount" label="金额"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              @click="handleClick(scope.row, 'kp')"
              type="text"
              size="small"
              :loading="loading"
              >开票</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="handleClick(scope.row, 'ch')"
              >冲红</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        width="30%"
        title="冲红原因"
        :visible.sync="dialogCh"
        append-to-body
      >
        <el-form
          :model="ruleFormGy"
          :rules="rulesGy"
          ref="ruleFormGy"
          label-width="100px"
        >
          <el-form-item label="冲红原因" prop="reason">
            <el-input v-model="ruleFormGy.reason"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogCh = false">取 消</el-button>
          <el-button type="primary" @click="submitFormGy" :loading="loading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </el-dialog>
  </el-container>
</template>

<script>
import api from "./api";
import print from "@/common/print.js";
import { getLodop } from "@/common/LodopFuncs";

import { mapGetters } from "vuex";
export default {
  components: {
    charge: () => import("./charge"),
    detail: () => import("./detail"),
    pagination: () => import("@/components/_com/pagination"),
    printView: () => import("@/components/_com/digDigitalPrint"),
  },
  data() {
    const validatorReason = (rule, value, callback) => {
      if (this.ruleForm.medicalCareType === "冲红" && !value) {
        callback(new Error("请填写冲红原因"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        medicalCareType: "",
        reason: "",
      },
      rules: {
        medicalCareType: [
          { required: true, message: "请选择开票类型", trigger: "change" },
        ],
        reason: [
          {
            validator: validatorReason,
            trigger: "blur",
          },
        ],
      },
      ruleFormGy: {
        reason: "",
      },
      rulesGy: {
        reason: [
          {
            required: true,
            message: "请填写冲红原因",
            trigger: "blur",
          },
        ],
      },
      loading: false,
      payWayNoGy: false,
      payWayGy: false,
      dialogCh: false,
      tableData: [],
      selectRowGy: "",
      condition: {
        // type: "收费",
        pageIndexOnView: 1,
        pageSize: 20,
        sort: "id",
        asc: false,
        hideFields: "", // dividePara, divideRes
      },
      entities: {
        items: [],
      },
      entity: {},
      chargStaffs: [],
      refundEntity: {},
      meta: {
        showPay: false,
        showDetail: false,
        showRefund: false,
        loading: false,
      },
      dateRange: [new Date(), new Date()],
      showPrintView: false,
      printNameList: [], // 打印机数组
      idCard: null, // 身份证信息
      row: null,
      selectRow: "",
    };
  },
  computed: {
    ...mapGetters(["dictEnum", "permission", "user"]),
  },
  created() {
    this.lodingData();

    // 初始化德卡ws
    this.$store.dispatch("deCardWsInit", {
      message: this.$message,
      callback: () => {},
    });
  },
  methods: {
    async toOrderDetails(row) {
      try {
        this.view(row);
      } catch (error) {
        this.$message.error(error);
      }
    },

    async openSelect(row) {
      const { payWay } = row;
      this.selectRow = row;

      if (payWay === "PW06") {
        // 公医
        const data = await api.getEBillPubliclList({
          payId: this.selectRow.id,
        });
        this.tableData = data;
        this.payWayGy = true;
        // this.$nextTick(() => {
        //   this.$refs.ruleFormGy.resetFields()
        // })
      } else {
        // this.$refs.ruleForm.resetFields()
        // 非公
        this.payWayNoGy = true;
        this.$nextTick(() => {
          this.$refs.ruleForm.resetFields();
        });
      }

      //
    },

    submitForm() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          //开票
          try {
            let data = "";
            this.loading = true;
            if (this.ruleForm.medicalCareType === "冲红") {
              data = await api.writeOffEBill({
                payNo: this.selectRow.no,
                reason: this.ruleForm.reason,
              });
            } else {
              data = await api.eBillOutpatient({
                payId: this.selectRow.id,
                medicalCareType: this.ruleForm.medicalCareType,
              });
            }

            window.open(data, "_blank");
            this.payWayNoGy = false;
          } catch (error) {
            this.$message.error(error);
          } finally {
            this.payWayNoGy = false;
            this.loading = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 公医列表操作
    async handleClick(row, type) {
      this.selectRowGy = row;
      if (type === "kp") {
        try {
          this.loading = true;
          const data = await api.eBillPublic({ payNo: row.payNo });
          window.open(data, "_blank");
          this.payWayGy = false;
        } catch (error) {
          this.$message.error(error);
        } finally {
          this.payWayGy = false;
          this.loading = false;
        }
      } else {
        this.dialogCh = true;
        this.$nextTick(() => {
          this.$refs.ruleFormGy.resetFields();
        });
      }
    },
    // 公医冲红
    async submitFormGy() {
      this.$refs.ruleFormGy.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true;
            const data = await api.writeOffEBill({
              payNo: this.selectRowGy.payNo,
              reason: this.ruleFormGy.reason,
            });
            window.open(data, "_blank");
          } catch (error) {
            this.$message.error(error);
          } finally {
            // this.$refs.ruleFormGy.resetFields()
            this.dialogCh = false;
            this.payWayGy = false;
            this.loading = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 获取打印机数据
    printConfig() {
      this.LODOP = getLodop(); // 创建一个LODOP对象
      // mac this.LODOP.GET_SYSTEM_INFO('NetworkAdapter.1.PhysicalAddress')
      let counter = this.LODOP.GET_PRINTER_COUNT(); // 获取打印机个数
      console.log("获取打印机个数", counter);
      //初始化下printNameList打印数组
      this.printNameList = [];
      for (let i = 0; i < counter; i++) {
        //将打印机存入printList数组中
        this.printNameList.push(this.LODOP.GET_PRINTER_NAME(i));
      }
      this.showPrintView = true;
    },
    async lodingData() {
      this.condition.startDate =
        this.$utils.fmtDate(this.dateRange[0]) + " 00:00:00";
      this.condition.endDate =
        this.$utils.fmtDate(this.dateRange[1]) + " 23:59:59";
      await this.page();
    },
    handleSortChange({ prop, order }) {
      this.condition.asc = order === "ascending";
      this.condition.sort = prop;
      this.page();
    },
    filterChanged(options) {
      Object.assign(this.condition, options);
      this.page();
    },
    types(type) {
      return (
        {
          未支付: "warning",
          退款: "danger",
        }[type] || ""
      );
    },
    dateRangeChanged(range) {
      if (range && range.length > 0) {
        this.condition.startDate = range[0] + " 00:00:00";
      } else {
        this.$message.warning("请选择开始时间！");
        return;
      }
      if (range && range.length > 1) {
        this.condition.endDate = range[1] + " 23:59:59";
      } else {
        this.$message.warning("请选择结束时间！");
        return;
      }
      this.page();
    },
    page(id, staff) {
      if (staff) {
        this.$set(this.condition, "operatorUserName", staff.realName);
      } else {
        this.$set(this.condition, "operatorUserId", null);
        this.$set(this.condition, "operatorUserName", null);
      }
      this.meta.loading = true;
      api
        .queryOpPaymentPageList(this.condition)
        // .queryOpPayment(this.condition)
        .then((res) => {
          res.items.forEach((r) => {
            if (r.feeDiscount < 0) {
              r.feeDiscount = -r.feeDiscount;
            }
          });
          this.entities = res;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.meta.loading = false;
        });
    },
    edit(row) {
      this.entity = JSON.parse(JSON.stringify(row));
      this.$nextTick(() => {
        this.meta.showPay = true;
      });
    },
    view(row) {
      this.entity = JSON.parse(JSON.stringify(row));
      this.$nextTick(() => {
        this.meta.showDetail = true;
      });
    },
    refund(row) {
      api
        .queryOpRefund({
          paymentId: row.id,
        })
        .then((res) => {
          if (res.items.length) {
            this.entity = JSON.parse(JSON.stringify(row));
            this.refundEntity = res.items[0];
            if (this.refundEntity.ifFinish) {
              this.$message.warning("此支付记录已经完成退费，禁止重复退费！");
            } else {
              this.$nextTick(() => {
                this.meta.showRefund = true;
              });
            }
          } else {
            this.$message.warning(
              "抱歉，未找到对应退费记录！请先通过医生执行退处方或者退申请单后，再进行退费操作。"
            );
          }
        });
    },
    chargeVoucher(row) {
      const data = {
        patientName: row.patientName,
        cardNo: "",
        no: row.no,
        opNo: row.opNo,
        paymentType: row.paymentType,
        amount: this.$utils.fmtFloat(row.amount, 2),
        opType: "",
        insurance: this.$utils.fmtFloat(row.insurance, 2),
        accountPayments: this.$utils.fmtFloat(row.accountPayments, 2),
        payment: this.$utils.fmtFloat(row.payment, 2),
        reg: null,
        items: [],
      };
      api.queryRp({ paymentId: row.id }).then((res) => {
        if (res.items && res.items.length) {
          api.queryReg({ opNo: res.items[0].opNo }).then((reg) => {
            if (reg.items && reg.items.length) {
              if (reg.items[0].cardNo) {
                this.$set(
                  data,
                  "cardNo",
                  `${reg.items[0].cardNo.substr(
                    0,
                    3
                  )}...${reg.items[0].cardNo.substr(
                    reg.items[0].cardNo.length - 4
                  )}`
                );
              }
              this.$set(data, "opType", reg.items[0].opType);
              if (
                res.items.filter((rp) => rp.rpClass === "就诊号").length > 0
              ) {
                this.$set(data, "reg", reg.items[0]);
              }
            }
            let nos = res.items
              .filter((rp) => rp.rpClass !== "就诊号")
              .map((m) => m.no);
            if (nos && nos.length) {
              api.queryRpDetail({ rpNos: nos }).then((result) => {
                result.items.forEach((element) => {
                  const item = res.items.filter((rp) => rp.no === element.rpNo);
                  element.rpQuantity = (item && item.quantity) || 1;
                });
                this.$set(data, "items", result.items);
                print.chargeVoucher(data);
              });
            } else {
              print.chargeVoucher(data);
            }
          });
        } else {
          this.$message.warning("未获取到费用明细信息！");
        }
      });
    },
    // 接收身份证读卡信息
    receiveIdCard(data) {
      this.meta.showPay = true;
      this.idCard = data;
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.type === "退费") {
        return "warning-row";
      }
      if (row.disabled) {
        return "gray-row";
      }
      return "";
    },
  },
};
</script>

<style>
.orange {
  color: orangered;
}

.el-table .warning-row {
  background: #fff7ea;
}

.el-table .gray-row {
  background: #fefbf4;
}
</style>
